module.exports = __webpack_public_path__ + "img/EBG.4806f51e.jpg";